<ng-container *transloco="let t">
    <div class="px-8 sm:px-32 space-background p-8" [ngStyle]="{'background': 'url(' + item.backgroundImage+ ')'}">
        <div class="flex flex-row" *ngIf="!mobile">
            <!--Left Pane-->
            <div class="basis-1/2" [ngClass]="{'order-last': item.layout === 'image-right' }">
                <div class="flex flex-col">
                    <div class="mt-12 justify-around">
                        <ng-container *ngFor="let slide of item.slides">
                            <img [src]="slide.imageUrl" [alt]="slide.title" [title]="slide.title" y>
                        </ng-container>
                    </div>
                </div>

            </div>
            <!--Right pane-->
            <div class="basis-1/2 m-auto">
                <div class="ml-4">
                    <div class="text-primary text-4xl font-bold">{{t(item.i18nTitleKey)}}</div>
                    <div class="mb-4">{{t(item.i18nDescriptionKey)}}</div>
                </div>
                <div class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 content-center">
                    <ng-container *ngFor="let point of item?.points">
                        <div class="flex flex-row">
                            <!--Icon-->
                            <div class="basis-1/6">
                                <img [src]="point?.imageUrl" class="w-16">
                            </div>
                            <!--text-->
                            <div class="flex flex-col ml-2 basis-5/6">
                                <!--Title-->
                                <div class="font-medium text-lg">{{t(point?.i18nKeyTitle)}}</div>
                                <!--Description-->
                                <div>{{t(point?.i18nDescription)}}</div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="flex flex-row" *ngIf="mobile">
            <div class="flex flex-col w-full">
                <h1 class="text-primary text-2xl sm:text-3xl font-bold text-center" [innerHTML]="item.i18nTitleKey|
                transloco"></h1>
                <div class="flex flex-row justify-center">
                    <img [src]="item.slides[0].imageUrl" [alt]="item.slides[0].title" [title]="item.slides[0].title"
                        class="w-56">
                </div>

                <mat-accordion class="mt-8" [displayMode]="'flat'">
                    <mat-expansion-panel *ngFor="let point of item?.points;  trackBy: trackByFn">
                        <mat-expansion-panel-header [collapsedHeight]="'56px'">
                            <mat-panel-title class="font-medium leading-tight">
                                <img [src]="point?.imageUrl" class="w-12 p-1">
                                <p>{{t(point?.i18nKeyTitle)}}</p>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="mt-8 text-white"> {{t(point?.i18nDescription)}}</div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </div>
</ng-container>